<template>
  <div>
    <div class="identity-title">请选择要注册的身份</div>
    <div class="selecte">{{tab==1&&tab>0?'已选身份:供应商':tab==2&&tab>0?'已选身份:采购商':''}}</div>
    <div class="identity-btn" v-if="tab==0">
        <div @click="hotelRegistration(3)">供应商<span>（酒店、民宿等）</span></div>
        <div @click="hotelRegistration(2)">采购商<span>（采购商、会务公司等）</span></div>
    </div>
    <div class="identity-bottom" v-if="tab>0">
        <el-button  type="primary" @click="tab=0" style="width: 140px; height: 40px;">返回</el-button>
    </div>    
  </div>
</template> 
<script>
export default {    
  name: '',
  components: {},
  props: {},
  data() {
    return {
        tab:0,
        type:0,
        i:0
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    hotelRegistration(i){
        this.$router.push({name:'PersonLregister',query:{type:i}})
    }
  }
};
</script>
<style lang="scss" scoped>
    .identity-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-top: 60px;
    }
    .identity-btn{
        display: flex;
        width: 60%;
        margin: 0 auto;
        justify-content: space-between;
        height: 80px;
        line-height: 80px;
        margin-bottom: 60px;
        div{
            width: 46%;
            border: 1px solid #ccc;
            border-radius: 6px;
            font-size: 16px;
            cursor: pointer;
            font-weight: bold;
        }
    }
    .identity-bottom{
        width: 60%;
        display: flex;
        justify-content: center;
        margin: 0 auto;
        margin-top: 60px;
    }
    .tabActive{
        background-color: var(--smtc-color-primary);
        color: #fff;
    }
    .selecte{
        margin-top: 10px;
        width: 60%;
        text-align: left;
        margin: 0 auto;
        margin-top: 30px;
        height: 30px;
        color: #999;
    }
    .identity-btn span{
        font-size: 14px;
        font-weight: normal;
        margin-left: 2px;
        color: #666;
    }
</style>
